import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { PermissionService } from 'src/app/services/permission-service/permission.service';

export const authGuard: CanActivateFn = (route, state) => {
  return inject(PermissionService).canActivate();
};